export const getPaymentPending = (payment: GQL.IPayment | undefined) => {
  return (
    payment &&
    (['pending'] as any).includes(payment.status)
  );
};


// WEBPACK FOOTER //
// ./src/helpers/payment/getPaymentPending.ts